import FileStates from 'FileStates';
import {ModPatternParams} from 'modbio/bulk-edit-mods/ModPatternConstants';
import * as TaskRunner from 'util/TaskRunner';

import {BulkEditModsResult} from './BulkEditModsConstants';

export function reindexStartPos(startPos: number | null): number | null {
  return startPos != null ? startPos - 1 : null; // startPos is 1-indexed on frontend for user
}

export function previewModPattern(
  params: Omit<ModPatternParams, 'shouldClone' | 'folderId'>
): Promise<Array<BulkEditModsResult>> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/preview-mod-pattern',
    data: params,
  });
}

export async function applyModPattern(
  params: ModPatternParams,
  isBulk: boolean
): Promise<Array<BulkEditModsResult>> {
  const results: Array<BulkEditModsResult> = await TaskRunner.postJSONPromise({
    url: '/1/api/apply-mod-pattern',
    data: params,
  });

  // Open the newly created sequence if the modifications were applied from a single-edit pathway
  const updatedSequenceIds = results
    .map((result) => result.updatedId)
    .filter((id): id is string => id != null);

  if (params.shouldClone && !isBulk && updatedSequenceIds.length > 0) {
    FileStates.get().openFolderItem(updatedSequenceIds[0]);
  }
  return results;
}
